export const canPushProduct = () => () => {
    return function (node) {
        if (! this.permission.has('write')) {
            this.logger.error('没有权限', [node])
            return false
        }

        const {bizNodeType, pkid} = node.data

        if (! pkid) {
            this.logger.error('只有制品才能更新', [node])
            return false
        }

        const bn = this.BizNode[bizNodeType]

        if (! bn.push) {
            const name = bn.typeName(this, node.parent)
            this.logger.error(`${name}不支持更新`, [node])
            return false
        }

        return bn.canWriteData(this, node)
    }
}

export const pushProduct = () => () => {
    return function (nodes) {
        return Promise.allSettled(
            [...nodes].map(
                async node => {
                    try {
                        const _n = this.nodeProxy(node)
                        await _n.push()
                        this.logger.info('更新模型制品成功', [node])
                    }
                    catch (err) {
                        this.logger.error(
                            `更新模型制品失败: ${err.message}`,
                            [node]
                        )

                        err.nodes = [node]
                        throw err
                    }
                }
            )
        )
    }
}
